import React from 'react'
import { FormattedMessage } from 'react-intl'
import TextField from './textfield'
import RadioField from './radiofield'
import { Link } from './localizedlink'
import { getError } from '../utility/formValidation'


const ReportFatturazione = ({ data, onChange, locale }) => {
  const { tipo, fiscalCode, street, number, cap, city, province, privacyInfo, privacyData, 
    pec, businessName, partitaIva, codiceFatturazione, companyEmail, iva, newsletter, errors } = data;
  const errorInfo = getError('privacyInfo', errors);
  const errorData = getError('privacyData', errors);
  const errorClass = (errorInfo || errorData) ? 'field--error' : '';
  return (
    <div className="billing">
      <div className="row">
        <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <h2><FormattedMessage id="Dati Fatturazione" defaultMessage="Dati Fatturazione" /></h2>
        </div>
      </div>
      <div className="row">
        <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <div className="row">
            {tipo === 'azienda' ? (
              <TextField field="businessName" label="Ragione Sociale*" onChange={onChange} errors={errors}
                value={businessName} className="col-sm-6" />
            ) : (
              <TextField field="fiscalCode" label="Codice Fiscale*" onChange={onChange} errors={errors}
                value={fiscalCode} className="col-sm-6" inputClass="field__input--uppercase" />
            )}
          </div>
          <div className="row">
            <TextField field="street" label="Via*" onChange={onChange} errors={errors}
              value={street} className="col-sm-6" />
            <TextField field="number" label="N.*" onChange={onChange} errors={errors}
              value={number} maxLength={10} className="col-sm-2" />
            <TextField field="cap" label="CAP*" onChange={onChange} errors={errors}
              value={cap} maxLength={10} className="col-sm-4" />
          </div>
          <div className="row">
            <TextField field="city" label="Comune*" onChange={onChange} errors={errors}
              value={city} className="col-sm-6" />
            <TextField field="province" label="Provincia*" onChange={onChange} errors={errors}
              value={province} className="col-sm-6" />
          </div>
          {tipo === 'azienda' && (
            <>
              <div className="row">
                <TextField field="partitaIva" label="P. IVA*" onChange={onChange} errors={errors}
                  value={partitaIva} className="col-sm-6" />
                <TextField field="fiscalCode" label="Codice Fiscale*" onChange={onChange} errors={errors}
                  value={fiscalCode} className="col-sm-6" inputClass="field__input--uppercase" />
              </div>
              {locale === 'it' && (
                <div className="row">
                  <TextField field="codiceFatturazione" label="Codice fatturazione elettronica" onChange={onChange} errors={errors}
                    value={codiceFatturazione} className="col-sm-6" />
                  <TextField field="pec" label="PEC" onChange={onChange} errors={errors}
                    value={pec} type="email" className="col-sm-6" />
                </div>
              )}
              <div className="row">
                <TextField field="companyEmail" label="Email" onChange={onChange} errors={errors} maxLength={260}
                  value={companyEmail} type="email" className="col-sm-6" />
              </div>
              <div className="row">
                <RadioField field="iva" label="iva-label"
                  value={iva} options={[{ label: 'Si', value: 'true' }, { label: 'No', value: 'false' }, { label: 'Split Payment', value: 'splitpayment' }]}
                  onChange={onChange} errors={errors} className="col-12" />
              </div>
            </>
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <div className={`field ${errorClass}`}>
            <div className="field__label">Newsletter</div>
            <label htmlFor="report-newsletter-check" className="field__label field__checkbox">
              <div className="field__textwrapper">
                <input id="report-newsletter-check" type="checkbox" name="newsletter"
                  value={newsletter} onChange={onChange} />
                <span className="checkmark"></span>
              </div>
              <FormattedMessage id="report-newsletter" />
            </label>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <div className={`field ${errorClass}`}>
            <div className="field__label">
              <FormattedMessage id="Privacy*" defaultMessage="Privacy*" />
            </div>
            <label htmlFor="report-privacy-info-check" className="field__label field__checkbox">
              <div className="field__textwrapper">
                <input id="report-privacy-info-check" type="checkbox" name="privacyInfo"
                  value={privacyInfo} onChange={onChange} />
                <span className="checkmark"></span>
              </div>
              <span>
                <FormattedMessage id="privacy-start" /> <Link to="/privacy/"><FormattedMessage id="privacy-link" /></Link>
              </span>
            </label>
            {!!errorInfo && !!errorInfo.message && <span className="field__message"><FormattedMessage id={errorInfo.message} /></span>}
            <label htmlFor="report-privacy-data-check" className="field__label field__checkbox">
              <div className="field__textwrapper">
                <input id="report-privacy-data-check" type="checkbox" name="privacyData"
                  value={privacyData} onChange={onChange} />
                <span className="checkmark"></span>
              </div>
              <FormattedMessage id="privacy-consent-report" />
            </label>
            {!!errorData && !!errorData.message && <span className="field__message"><FormattedMessage id={errorData.message} /></span>}
          </div>
        </div>
      </div>
    </div >
  )
};

export default ReportFatturazione;